export const logoutReasons = Object.freeze({
    IDLE: 'Your account has been idle for a while. For security reasons, you have been automatically logged out.',
    MANUAL: 'You have been successfully logged out.',
    EXPIRED: 'Your session has expired. Please log in again.',
});
